import { Link } from "react-router-dom";

export function ArticleCard({ article, variant = "default" }) {
  if (!article) return null;
  if (variant === "feature") {
    return (
      <Link to={`/article/${article.slug}`} className="block group" data-testid={`article-card-${article.slug}`}>
        <div className="img-zoom aspect-[16/10] overflow-hidden bg-[#EFECE5]">
          {article.featured_image && <img src={article.featured_image} alt={article.title} className="w-full h-full object-cover" loading="lazy" />}
        </div>
        <div className="overline text-[#B4533C] mt-4">{prettyCategory(article.category)}</div>
        <h3 className="font-serif text-2xl md:text-3xl leading-tight mt-2 group-hover:text-[#B4533C] transition-colors">{article.title}</h3>
        <p className="mt-2 text-sm text-[#4A4742] line-clamp-2">{article.excerpt}</p>
        <div className="mt-3 text-xs text-[#4A4742] font-mono">{article.author}</div>
      </Link>
    );
  }
  return (
    <Link to={`/article/${article.slug}`} className="block group" data-testid={`article-card-${article.slug}`}>
      <div className="img-zoom aspect-[4/3] overflow-hidden bg-[#EFECE5]">
        {article.featured_image && <img src={article.featured_image} alt={article.title} className="w-full h-full object-cover" loading="lazy" />}
      </div>
      <div className="overline text-[#B4533C] mt-3">{prettyCategory(article.category)}</div>
      <h3 className="font-serif text-xl leading-tight mt-1 group-hover:text-[#B4533C] transition-colors">{article.title}</h3>
      <div className="mt-2 text-xs text-[#4A4742] font-mono">{article.author} · {new Date(article.updated_at).toLocaleDateString()}</div>
    </Link>
  );
}

export function DealCard({ deal }) {
  if (!deal) return null;
  return (
    <Link to={`/deal/${deal.slug}`} className="block editorial-card img-zoom" data-testid={`deal-card-${deal.slug}`}>
      <div className="aspect-[16/10] overflow-hidden bg-[#EFECE5]">
        {deal.featured_image && <img src={deal.featured_image} alt={deal.title} className="w-full h-full object-cover" loading="lazy" />}
      </div>
      <div className="p-5">
        <div className="overline text-[#B4533C]">Deal Alert · {deal.airline || "Multiple airlines"}</div>
        <h3 className="font-serif text-xl leading-tight mt-2">{deal.title}</h3>
        <div className="mt-4 grid grid-cols-2 grid-borders border-t border-l border-[#D6CFC4]">
          <div className="p-3">
            <div className="overline text-[#4A4742]">Cash</div>
            <div className="font-mono text-base">{deal.cash_price ? `$${deal.cash_price}` : "—"}</div>
          </div>
          <div className="p-3">
            <div className="overline text-[#4A4742]">Points</div>
            <div className="font-mono text-base">{deal.points_price ? `${deal.points_price.toLocaleString()}` : "—"}</div>
          </div>
        </div>
      </div>
    </Link>
  );
}

export function DestinationCard({ dest, size = "default" }) {
  if (!dest) return null;
  return (
    <Link to={`/destination/${dest.slug}`} className="block relative overflow-hidden group scrim-bottom img-zoom" data-testid={`dest-card-${dest.slug}`}>
      <div className={size === "large" ? "aspect-[4/5]" : "aspect-[4/3]"}>
        {dest.hero_image && <img src={dest.hero_image} alt={dest.destination_name} className="w-full h-full object-cover" loading="lazy" />}
      </div>
      <div className="absolute bottom-0 left-0 right-0 p-5 z-10 text-white">
        <div className="overline">{dest.country}</div>
        <div className="font-serif text-2xl md:text-3xl leading-tight mt-1">{dest.destination_name}</div>
      </div>
    </Link>
  );
}

export function ReviewCard({ review }) {
  if (!review) return null;
  return (
    <Link to={`/review/${review.slug}`} className="block editorial-card" data-testid={`review-card-${review.slug}`}>
      <div className="img-zoom aspect-[16/9] overflow-hidden bg-[#EFECE5]">
        {review.featured_image && <img src={review.featured_image} alt={review.product_name} className="w-full h-full object-cover" loading="lazy" />}
      </div>
      <div className="p-5">
        <div className="overline text-[#B4533C]">{review.review_type} review</div>
        <div className="font-serif text-xl leading-tight mt-1">{review.brand_name} — {review.product_name}</div>
        <div className="mt-3 flex items-center gap-3 text-sm">
          <span className="font-mono text-[#1B3B36] text-lg">{review.rating.toFixed(1)}</span>
          <span className="text-[#4A4742]">/ 5.0</span>
        </div>
      </div>
    </Link>
  );
}

export function prettyCategory(c) {
  const map = {
    "travel-hacks": "Travel Hacks",
    "points-miles": "Points & Miles",
    "airlines": "Airlines",
    "hotels": "Hotels",
    "destinations": "Destinations",
    "reviews": "Reviews",
    "credit-cards": "Credit Cards",
    "videos": "Videos",
    "deals": "Deals",
  };
  return map[c] || c;
}
